import { create } from "zustand";
import { fetchApiSpec } from "./api";

export type SpecStatus = "idle" | "loading" | "ready" | "error";

interface ApiDocsState {
  spec: object | null;
  status: SpecStatus;
  // Fetches the OpenAPI spec once and caches it for the app instance's lifetime
  // (cleared on reload). No-ops while loading or already loaded.
  load: () => Promise<void>;
}

export const useApiDocsStore = create<ApiDocsState>((set, get) => ({
  spec: null,
  status: "idle",
  load: async () => {
    const { status } = get();
    if (status === "loading" || status === "ready") return;
    set({ status: "loading" });
    try {
      const spec = await fetchApiSpec();
      set({ spec, status: "ready" });
    } catch {
      set({ status: "error" });
    }
  },
}));
